import React from 'react';
import PropTypes from 'prop-types';

import InputText from './input-text';
import { usePostUpdateLinkedInUrl } from '../../../../../services/profiles/contributor-settings-service';

export default function LinkedIn({ url, onUpdate }) {
  const [{ loading, error }, post] = usePostUpdateLinkedInUrl();

  const onChange = value => {
    post(value).then(() => onUpdate(value));
  };

  return (
    <InputText
      initialValue={url}
      label="LinkedIn"
      placeholder="Example https://www.linkedin.com/in/myname"
      onChange={onChange}
      isLoading={loading}
      error={error}
    />
  );
}

LinkedIn.propTypes = {
  url: PropTypes.string,
  onUpdate: PropTypes.func,
};

LinkedIn.defaultProps = {
  url: null,
  onUpdate: () => null,
};
